import PickerIcon from 'Assets/images/pages/web-chat/select-date.svg';
import { Field, Form, Formik } from 'formik';
import { DropdownField, InputField, SingleDatePickerField } from 'Modules/Formik';
import moment from 'moment';
import { any, objectOf } from 'prop-types';
import React, { forwardRef } from 'react';
import { Image } from 'semantic-ui-react';

import css from './PatientDetailsForm.less';
import { PatienDetailSchema } from './validate';

const optionsGender = [
  {
    key: 'male',
    value: 'male',
    text: 'Male',
  },
  {
    key: 'female',
    value: 'female',
    text: 'Female',
  },
  {
    key: 'other',
    value: 'other',
    text: 'Other',
  },
];
const PatientDetailsForm = forwardRef(({ initialValues }, ref) => (
  <div className={css.content}>
    <Formik
      initialValues={initialValues}
      onSubmit={() => true}
      validationSchema={PatienDetailSchema}
      innerRef={ref}>
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <div style={{ display: 'flex', marginBottom: '1rem' }}>
            <div style={{ flex: 1, marginRight: 20 }}>
              <Field
                label="Full Name as in Identity Card"
                name="patientName"
                component={InputField}
              />
            </div>
            <div style={{ flex: 1 }}>
              <Field
                style={{ flex: 1 }}
                label="NRIC / Passport Number"
                name="patientNric"
                component={InputField}
              />
            </div>
          </div>
          <div style={{ display: 'flex', marginBottom: '1rem' }}>
            <div style={{ flex: 1, marginRight: 20 }}>
              <Field
                label="Gender at Birth"
                name="patientGender"
                component={DropdownField}
                options={optionsGender}
              />
            </div>
            <div style={{ flex: 1 }}>
              <Field
                label="Date of Birth"
                name="patientDob"
                component={SingleDatePickerField}
                isOutsideRange={day => moment().isBefore(day)}
                inputIconPosition="after"
                customInputIcon={<Image src={PickerIcon} />}
                monthPick
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  </div>
));

PatientDetailsForm.propTypes = {
  initialValues: objectOf(any).isRequired,
};

export default PatientDetailsForm;
